import { useState } from "react";
import { BAY_ISLE, TERRACOTTA, SEMI_SWEET, PROPER_GREY, PLASTER, WHITE, RULE, FONT_DISPLAY, FONT_SERIF, FONT_BODY } from "../theme";

function Stars({ count = 5 }) {
  return (
    <div style={{ display: "flex", gap: 3, marginBottom: 14 }}>
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 14 14" fill={TERRACOTTA} xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1l1.545 3.09L12 4.635l-2.5 2.41.59 3.41L7 8.77l-3.09 1.685.59-3.41L2 4.635l3.455-.545L7 1z" />
        </svg>
      ))}
    </div>
  );
}

function TestimonialCard({ name, role, quote, stars, dark }) {
  const bg = dark ? "rgba(255,255,255,0.06)" : WHITE;
  const border = dark ? "rgba(255,255,255,0.1)" : RULE;
  const quoteColor = dark ? "rgba(242,238,234,0.92)" : SEMI_SWEET;
  const nameColor = dark ? WHITE : BAY_ISLE;
  const roleColor = dark ? "rgba(242,238,234,0.55)" : PROPER_GREY;

  return (
    <div style={{
      background: bg,
      border: `1px solid ${border}`,
      borderRadius: 14,
      padding: "24px 22px",
      display: "flex",
      flexDirection: "column",
    }}>
      <Stars count={stars} />
      <p style={{
        fontFamily: FONT_SERIF,
        fontStyle: "italic",
        fontSize: 15,
        color: quoteColor,
        lineHeight: 1.7,
        flex: 1,
        marginBottom: 18,
      }}>
        "{quote}"
      </p>
      <div>
        <p style={{ fontFamily: FONT_BODY, fontWeight: 700, fontSize: 12.5, color: nameColor, marginBottom: 2 }}>
          {name}
        </p>
        <p style={{ fontFamily: FONT_BODY, fontSize: 11, color: roleColor, letterSpacing: "0.04em", textTransform: "uppercase" }}>
          {role}
        </p>
      </div>
    </div>
  );
}

export default function Testimonials({ reviews, dark = false, label = "What clients say" }) {
  const [page, setPage] = useState(0);
  const perPage = 3;
  const total = reviews.length;
  const pages = Math.ceil(total / perPage);
  const visible = reviews.slice(page * perPage, page * perPage + perPage);

  const sectionBg = dark ? BAY_ISLE : PLASTER;
  const labelColor = dark ? "rgba(242,238,234,0.5)" : PROPER_GREY;
  const headingColor = dark ? WHITE : BAY_ISLE;
  const dotActive = dark ? WHITE : BAY_ISLE;
  const dotInactive = dark ? "rgba(255,255,255,0.25)" : RULE;

  return (
    <div style={{ background: sectionBg, padding: "4rem 20px" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        <p style={{
          textAlign: "center",
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: labelColor,
          marginBottom: 10,
          fontFamily: FONT_BODY,
        }}>
          {label}
        </p>
        <p style={{
          textAlign: "center",
          fontFamily: FONT_DISPLAY,
          fontSize: "clamp(22px, 4vw, 30px)",
          color: headingColor,
          fontWeight: 400,
          marginBottom: 36,
        }}>
          Real results, real clients
        </p>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 16,
          marginBottom: pages > 1 ? 28 : 0,
        }}>
          {visible.map((r, i) => (
            <TestimonialCard key={i} dark={dark} {...r} />
          ))}
        </div>

        {pages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            {Array.from({ length: pages }).map((_, i) => (
              <button
                key={i}
                onClick={() => setPage(i)}
                aria-label={`Page ${i + 1}`}
                style={{
                  width: i === page ? 22 : 8,
                  height: 8,
                  borderRadius: 999,
                  border: "none",
                  background: i === page ? dotActive : dotInactive,
                  cursor: "pointer",
                  padding: 0,
                  transition: "width 0.2s, background 0.2s",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
